(function () {
    'use strict';

    const deps = [
        'ngSanitize',
        'doclr.keycloak',
        'doclr.appconfig',
        'doclr.adminagenda',
        'doclr.dashboard',
        'doclr.security',
        'doclr.werkschema',
        'doclr.berichten',
        'doclr.user',
        'doclr.patienten',
        'doclr.instellingen',
        'doclr.statistieken',
        'doclr.beschikbaarheidrelation',
        'doclr.availabilityReleaseStrategy',
        'doclr.customMessage',
        'doclr.blocklist',
        'doclr.disciplines',
        'doclr.beschikbaarheidtypes',
        'doclr.activiteiten',
        'doclr.beschikbaarheden',
        'doclr.ipdc',
        'doclr.activiteitengroep',
        'doclr.components',
        'doclr.components.agenda',
        'doclr.components.notification',
        'doclr.components.loading',
        'doclr.components.disclaimer',
        'doclr.components.copyright',
        'doclr.components.vertalingen',
        'doclr.pivot',
        'doclr.praktijk',
        'ui.router',
        'doclr.resources.common',
        'rcForm',
        'ngMaterial'
    ];

    var console = console || {
        log: function () {
        }
    };

    angular.module('doclr.admin.app', deps)
        .config(function ($injector, $uiViewScrollProvider, $stateProvider, $urlRouterProvider, userContext) {
            moment.locale('nl');

            if (userContext.isDokter() && userContext.defaultAgendaId && !userContext.isAdmin()) {
                $urlRouterProvider.otherwise('/dashboard');
            } else {
                $urlRouterProvider.otherwise('/agenda');
            }


            /*
             A much-requested feature: the autoscroll attribute. This adds an autoscroll="expr" attribute to uiView, just like ngInclude has. It also replaces the $anchorScroll call in uiView with a custom
             provider which scrolls the element attached to uiView into the current view instead. This should allow a more fine-tuning for designers by scrolling automatically to the activate uiView without
             manipulating anchors. Calling $uiViewScrollProvider.useAnchorScroll() will restore the current
             behavior or calling $anchorScroll instead.

             useAnchorScroll zorgt ervoor dat het standaard angular gedrag ivm anchor scrolling terug geactiveeerd is.
             http://docs.angularjs.org/api/ng.$anchorScroll
             Dit is nodig ivm scrolling issue met de agenda.
             */
            $uiViewScrollProvider.useAnchorScroll();

        })
        .run(function ($rootScope, $state, $stateParams, $injector, $animate, $log, userContext, afspraakMonitor, navAppointmentId, openAppointmentService) {
            /* jshint unused: false */
            // De analytics library die we gebruiken wordt geinitialiseerd bij het eerste maal injecteren als
            // dependency (in provider $get functie)

            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            $animate.enabled(false);
            $rootScope.$on('$stateChangeError', $log.error.bind($log.error));
            $rootScope.$on('afspraak.gewijzigd', function (name, action, afspraak) {
                if (action === 'kopiëren naar klembord' || userContext.isTeleSecretariaat()) {
                    afspraakMonitor.toonWijziging(action, afspraak);
                }
            });
            if (navAppointmentId) {
                const deregister = $rootScope.$on('$stateChangeSuccess', function () {
                    deregister();
                    openAppointmentService.openAppointment(navAppointmentId, true);
                });
            }
        })
        .controller('headerController', function ($scope, praktijkContext) {
            $scope.praktijkContext = praktijkContext;
        })
        .controller('navbarController', function ($scope, userContext, omgeving, praktijkContext, slicesService, Users, appContext, $window, sortByProperty) {
            $scope.userContext = userContext;
            $scope.praktijkContext = praktijkContext;
            $scope.omgeving = omgeving;
            $scope.slicesLoaderHolder = slicesService.slicesLoaderHolder;
            $scope.praktijken = [];
            $scope.appContext = appContext;

            $scope.logout = function () {
                document.location = appContext.adminFeUrl + "/" + appContext.tenantUrlName + "/logout?from=" + encodeURIComponent(document.location.href);
            };

            $scope.wijzigPraktijk = function (praktijk) {
                Users.wijzigPraktijk(praktijk.id)
                    .then(function onSuccess(response) {
                        $window.location.href = response.headers('Location');
                    });
            };

            $scope.adminFeUrl = appContext.adminFeUrl;
            $scope.tenantUrlName = appContext.tenantUrlName;
            $scope.navbarItems = appContext.modules.map(m => m.navbarItems).flat().sort(sortByProperty(x => x.order));
            $scope.menuItems = appContext.modules.map(m => m.configurationMenuItems).flat().sort(sortByProperty(x => x.order));

            Users.getPraktijken().then(function (praktijken) {
                $scope.praktijken = praktijken;
            });

            $scope.hasDashboard = function () {
                return userContext.isDokter() && userContext.defaultAgendaId;
            };
            $scope.isAdminUser = userContext.admin;
        });
})();